import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import classNames from "classnames";
import "./style.scss";

const SimpleLink = forwardRef(({ linktype, text, href, className, callback, isDisabled }, ref) => {
  const classes = classNames("simple-link", "white", className);
  if (/^https?:\/\/$/.test(href)) {
    href = null;
  }
  if (linktype === "internal") {
    return (
      <Link
        ref={ref}
        className={classes}
        to={href}
        onClick={e => {
          typeof callback === "function" && callback(e);
        }}
      >
        <span className="buttonText">{text}</span>
      </Link>
    );
  }
  return (
    <a
      ref={ref}
      className={classes}
      href={href}
      target="__blank"
      onClick={e => {
        if (isDisabled !== true) {
          typeof callback === "function" && callback(e);
        }
      }}
    >
      <span className="buttonText">{text}</span>
    </a>
  );
});
SimpleLink.displayName = "SimpleLink";
export default SimpleLink;
SimpleLink.propTypes = {
  href: PropTypes.string,
  text: PropTypes.string,
  linktype: PropTypes.string,
  className: PropTypes.string,
  callback: PropTypes.func
};
